
import OutfitPage from '~/components/bundle-page/outfit/outfit-page'
export default {
  name: 'OutfitSlug',
  components: {
    OutfitPage,
  },
  async asyncData({ error, app: { $storyblok, i18n }, params }) {
    try {
      const lang = i18n?.locale.split('-')?.[0]
      const { stories } = await $storyblok.getStories(
        `by_slugs=${lang}/pages/bundle-page/lole-lookbook,${lang}/pages/product-page/product-page`
      )
      const wording = stories.find((s) => s.name === 'outfit_page').content
      const bundle = wording.bundles.find(
        (b) => b.bundleSlug === params.slug && b?.disabled !== true
      )
      delete wording.bundles
      if (!bundle)
        error({
          statusCode: 404,
          message: `[BUNDLE PAGE] Bundle not found (${params.slug}):`,
        })
      return {
        bundle,
        wording,
        wordingPDP: stories.find((s) => s.name === 'product-page')?.content,
      }
    } catch (e) {
      console.log('[BUNDLE PAGE] Internal error:', e)
      error({
        statusCode: 500,
        message: '[BUNDLE PAGE] Internal error: ' + e,
      })
    }
  },
  head() {
    return {
      title: this.bundle?.bundleMetaTitle,
      description: this.bundle?.bundleMetaDescription,
      image: this.bundle?.bundleMetaThumbnail,
    }
  },
}
